import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { PropertyManagementFeeSettingValidation } from 'uplisting-frontend/validations';

export default class PropertyManagementFeeSettingRepositoryService extends BaseRepositoryService<
  ModelRegistry['property-management-fee-setting']
> {
  recordName = 'property-management-fee-setting';
  implementMethods = ['buildChangeset', 'findAll', 'unloadAll'];

  validation = PropertyManagementFeeSettingValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/property-management-fee-setting': PropertyManagementFeeSettingRepositoryService;
  }
}
